import React from 'react';
import { EnumDropdown, DefaultDropdownProps } from 'framework/form';
import { DOCUMENT_TYPES } from './educationConstants';

const DocumentTypeInput = (props: Omit<DefaultDropdownProps, 'options'>) => {
  return <EnumDropdown {...props} options={DOCUMENT_TYPES} />;
};

export default DocumentTypeInput;
